import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import Styles from "../homework/assets/Form.module.css";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
// import { ImageLink } from "../../constants";

const AddPage = () => {
  const location = useLocation();
  const pageData = location.state;
  const [formSubmitted, setFormSubmitted] = useState(false);
  const navigator = useNavigate();
  const [data, setData] = useState({
    pageName: pageData?.pageName || "",
  });

  const handleChange = (e) => {
    const { name } = e.target;
    setData({
      ...data,
      [name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!data.pageName) {
      return;
    }
    try {
      const response = await axiosInstance.post(`admin/page/createPage`, {
        pageName: data.pageName,
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/page");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.put(
        `admin/page/updatePage/${pageData?._id}`,
        {
          pageName: data.pageName,
        },
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator("/page");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  return (
    <div>
      <div className="mt-4 mb-4">
        <div className="row">
          <div className="col-sm-6">
            <h4 className="page-title">{pageData?._id ? "Edit Page" : "Add Page"}</h4>
          </div>
        </div>
        <Card className="mt-4">
          <CardBody>
            <Row>
              <Col md="8">
                <form
                  className="ps-5 pe-5 pt-3"
                  onSubmit={pageData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="form-group row mb-4">
                    <Label
                      for="inputPassword"
                      className="col-sm-4 col-form-label"
                    >
                      Page Name
                    </Label>
                    <div className="col-sm-7">
                      <Input
                        type="text"
                        className="form-control"
                        id="inputPassword"
                        placeholder="Enter page name"
                        invalid={!pageData && !data.pageName && formSubmitted}
                        name="pageName"
                        value={data.pageName}
                        onChange={(e) => handleChange(e)}
                      />
                      <FormFeedback>Page name is required</FormFeedback>
                    </div>
                  </div>
                  <div className="form-group row mb-4">
                    <Label
                      for="inputPassword"
                      className="col-sm-4 col-form-label"
                    >
                      <b className="ms-2"></b>
                    </Label>
                    <div className="col-sm-7 d-flex">
                      <div className={`${Styles.submit_button}`}>
                        <Button type="submit">
                          {pageData?._id ? "Update" : "Save"}
                        </Button>
                      </div>
                      <div className={`${Styles.cancel_button} me-4 mx-2`}>
                        <Link to="/page">
                          {" "}
                          <Button className={`${Styles.cancel_button}`}>
                            Cancel
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default AddPage;
